/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { externalReceiveWorkOSWebhook } from "../funcs/externalReceiveWorkOSWebhook.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ReceiveWorkOSWebhookRequest } from "../models/operations/receiveworkoswebhook.js";
import { unwrapAsync } from "../types/fp.js";

export class External extends ClientSDK {
  /**
   * receiveWorkOSWebhook external
   *
   * @remarks
   * Receive and enqueue a WorkOS webhook event.
   */
  async receiveWorkOSWebhook(
    request?: ReceiveWorkOSWebhookRequest | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(externalReceiveWorkOSWebhook(
      this,
      request,
      options,
    ));
  }
}
